import { localDeleteStorage, localGetStorage, localSetStorage } from '@/lib/storage';
import { addNow, diffNow } from '@/lib/timer';
import { toast } from 'react-toastify';
// pinComponent에서 중복 된 함수를 여기로 빼자

// 핀번호 5회 초과시 사용 못함 적용
export const setPinExceed = () => {
  const payload = {
    key: 'pinExceed',
    value: {
      expire: addNow({ num: 1, type: 'd' }),
    },
  };
  localSetStorage(payload);
};

// 5회 초과 후 24시간 경과 체크
export const isPinExceed = (): boolean => {
  const name = 'pinExceed';
  const re = localGetStorage(name);
  if (re === null) return false;

  if (diffNow(re?.expire) < 0) {
    toast.error('5회 인증 실패로 24시간 동안 핀번호 사용이 불가능합니다.');
    return true;
  }
  localDeleteStorage(name);
  return false;
};

// 핀 번호 인증 완료 후 카운트 리셋
export const resetSnsPinCheck = (re: any) => {
  const snsPayload = {
    key: 'snsAddress',
    value: {
      ...re,
      failCount: 5,
    },
  };
  localSetStorage(snsPayload);
};